export const FORM_DEFAULT_ORDER_BY: FormSortBy = 'createdAt-desc'
export const FORM_SORT_BY = ['createdAt', 'name', 'type'] as const
export type FormSortBy = `${(typeof FORM_SORT_BY)[number]}-${'asc' | 'desc'}`
export const FORMS_DEFAULT_SEARCH = {
  name: '',
  sortBy: FORM_DEFAULT_ORDER_BY,
  createdAt: null,
} as const
